<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6" class="flex">
        <span>补贴单号</span>
        <el-input v-model="search.subsidyNo" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>售后工单编号</span>
        <el-input v-model="search.smsNo" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>销售单行号</span>
        <el-input v-model="search.salesNo" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>发放状态</span>
        <el-select
          v-model="distributionState"
          placeholder="请选择"
          clearable
          style="width:100%"
          @change="changeDistributionState"
        >
          <el-option
            v-for="(item, index) in distributionStateList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>补贴类型</span>
        <el-select
          v-model="search.subsidyType"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in subsidyTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>旧机品牌</span>
        <el-select
          v-model="search.oldMachineBrand"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in oldMachineBrandList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>旧机品类</span>
        <el-select
          v-model="search.oldMachineType"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in oldMachineCategoryList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>网点编号</span>
        <el-input v-model="search.outletsNo" placeholder="请输入"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>网点名称</span>
        <el-input v-model="search.outletsName" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>收款人姓名</span>
        <el-input v-model="search.payeeName" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>收款人手机号</span>
        <el-input v-model="search.payeeTel" placeholder="请输入"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>渠道</span>
        <el-input v-model="search.channel" placeholder="请输入"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>鉴定时间</span>
        <el-date-picker
          v-model="appraisalTime"
          clearable
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:100%"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="6" class="flex">
        <span>来源系统</span>
        <el-select
          v-model="search.sourceSystem"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(item, index) in sourceSystemList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="button-container">
      <el-button type="primary" size="medium" @click="getList">查询</el-button>
      <el-button size="medium" @click="resetForm">重置</el-button>
      <el-button size="medium" @click="exportExcel">导出</el-button>
      <el-button size="medium" @click="batchDistribution">批量发放</el-button>
      <!-- <el-button size="medium" @click="exportExcel">发放完成导入</el-button> -->
      <div class="distribution-import-button">
        <file-upload
          ref="fileupload"
          @addUpload="importSuccessExcel"
          :title="'发放完成导入'"
          :limit="1"
        />
      </div>
      <div class="distribution-import-button">
        <file-upload
          ref="fileupload"
          @addUpload="importFailExcel"
          :title="'发放失败导入'"
          :limit="1"
        />
      </div>

      <!-- <file-upload
        ref="fileupload"
        @addUpload="importUpdateStockByExcel"
        :title="'批量审核'"
        :limit="1"
      /> -->
      <!-- <el-button size="medium" @click="exportExcel">发放失败导入</el-button> -->
      <el-button size="medium" @click="downloadSuccessTemplate"
        >发放成功模板下载</el-button
      >
      <el-button size="medium" @click="downloadFailTemplate"
        >发放失败模板下载</el-button
      >
    </div>
    <div class="button-container">
      <div class="distribution-import-button">
        <file-upload
          ref="fileupload"
          @addUpload="importInvoicingExcel"
          :title="'批量开票完成'"
          :limit="1"
        />
      </div>
      <el-button size="medium" @click="downloadInvoicingTemplate"
      >批量开票模板</el-button
      >
    </div>
    <div>
      <el-tabs v-model="tabActiveName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="全部"></el-tab-pane>
        <el-tab-pane label="补贴待发放" name="补贴待发放"></el-tab-pane>
        <el-tab-pane label="补贴发放中" name="补贴发放中"></el-tab-pane>
      </el-tabs>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="补贴单号"
        prop="subsidyNo"
        width="180"
      ></el-table-column>
      <el-table-column label="补贴类型" prop="outletsName" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.subsidyType === 1">以旧换新</span>
          <span v-if="scope.row.subsidyType === 2">回收</span>
        </template>
      </el-table-column>
      <el-table-column
        label="来源系统"
        prop="sourceSystem"
        width="120"
      ></el-table-column>
      <el-table-column
        label="发放状态"
        prop="statusDesc"
        width="120"
      ></el-table-column>
      <el-table-column
        label="旧机品牌"
        prop="oldMachineBrand"
        width="120"
      ></el-table-column>
      <el-table-column
        label="旧机品类"
        prop="oldMachineTypeName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="旧机规格"
        prop="oldMachineSpecification"
        width="100"
      ></el-table-column>
      <el-table-column
        label="收款人姓名"
        prop="payeeName"
        width="200"
      ></el-table-column>
      <el-table-column
        label="收款人手机号"
        prop="payeeTel"
        width="120"
      ></el-table-column>
      <el-table-column
        label="鉴定补贴金额"
        prop="subsidyAmount"
        width="120"
      ></el-table-column>
      <el-table-column
        label="售后工单号"
        prop="infoNo"
        width="140"
      ></el-table-column>
      <el-table-column
        label="销售单行号"
        prop="salesNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="渠道"
        prop="channel"
        width="120"
      ></el-table-column>
      <el-table-column
        label="网点编号"
        prop="outletsNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="网点名称"
        prop="outletsName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="鉴定时间"
        prop="appraisalDate"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
          <el-button
            type="text"
            @click="openDistribution(scope.row.subsidyNo)"
            v-if="scope.row.statusDesc === '补贴待发放'"
            >发放</el-button
          >
          <el-button
            type="text"
            @click="openDistributionSuccess(scope.row.subsidyNo)"
            v-if="scope.row.statusDesc === '补贴发放中'"
            >发放完成</el-button
          >
          <el-button
            type="text"
            @click="openDistributionFail(scope.row.subsidyNo)"
            v-if="scope.row.statusDesc === '补贴发放中'"
            >发放失败</el-button
          >
          <el-button
            type="text"
            @click="finishInvoice(scope.row.subsidyNo)"
            v-if="scope.row.statusDesc === '待开票'"
            >开票完成</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <distributionDialog
      ref="distributionDialogRef"
      @distributionFinished="distributionFinished"
    ></distributionDialog>
    <batchDistributionDialog
      ref="batchDistributionDialogRef"
      @batchDistributionFinished="batchDistributionFinished"
    ></batchDistributionDialog>
    <distributionSuccessDialog
      ref="distributionSuccessDialogRef"
      @distributionFinishedSuccess="distributionFinishedSuccess"
    ></distributionSuccessDialog>
    <distributionFailDialog
      ref="distributionFailDialogRef"
      @distributionFail="distributionFail"
    ></distributionFailDialog>
    <distributionImportResultDialog
      ref="distributionImportResultDialogRef"
    ></distributionImportResultDialog>
    <batchReviewImportResultDialog
      ref="batchReviewImportResultDialogRef"
    ></batchReviewImportResultDialog>
    <batch-invoice-import-result-dialog
      ref="BatchInvoiceImportResultDialog"
    ></batch-invoice-import-result-dialog>
  </div>
</template>

<script>
import fileUpload from "./components/FileUpload";
import distributionDialog from "./components/DistributionDialog";
import batchDistributionDialog from "./components/BatchDistributionDialog";
import distributionSuccessDialog from "./components/DistributionSuccessDialog";
import distributionFailDialog from "./components/DistributionFailDialog";
import distributionImportResultDialog from "./components/DistributionImportResultDialog";
import batchReviewImportResultDialog from "./components/BatchReviewImportResultDialog";
import BatchInvoiceImportResultDialog from "@/views/oldMachineSubsidy/components/BatchInvoiceImportResultDialog.vue";

export default {
  props: {},
  data() {
    return {
      // 表格数据
      list: [],
      //列表总条数
      total: 0,
      listLoading: false,
      search: {
        // 补贴单号
        subsidyNo: "",
        // 售后工单号
        smsNo: "",
        // 销售单号
        salesNo: "",
        // 补贴类型
        subsidyType: "",
        // 旧机品牌
        oldMachineBrand: "",
        // 旧机类型
        oldMachineType: "",
        // 网点编码
        outletsNo: "",
        // 网点名称
        outletsName: "",
        // 收款人姓名
        payeeName: "",
        // 收款人电话
        payeeTel: "",
        // 渠道
        channel: "",
        // 鉴定开始时间
        appraisalStartDate: "",
        // 鉴定结束时间
        appraisalEndDate: "",
        // 来源系统
        sourceSystem: "",
        // 页码
        currPage: 1,
        // 条数
        pageSize: 10,
        payType: 0
      },
      // 鉴定时间
      appraisalTime: [],
      // 默认发放状态是补贴待发放
      distributionState: 3,
      // 发放状态列表
      distributionStateList: [
        {
          label: "补贴待发放",
          value: 3
        },
        {
          label: "补贴发放中",
          value: 4
        },
        {
          label: "待开票",
          value: 5
        },
        {
          label: "补贴发放失败",
          value: 6
        },
        {
          label: "开票完成",
          value: 7
        },
        {
          label: "已关闭",
          value: 8
        }
      ],
      // 补贴类型
      subsidyTypeList: [
        {
          label: "以旧换新",
          value: 1
        },
        {
          label: "回收",
          value: 2
        }
      ],
      // 旧机品牌
      oldMachineBrandList: [
        {
          label: "格力",
          value: "GREE"
        },
        {
          label: "非格力",
          value: "OTHER"
        }
      ],
      // 旧机品类
      oldMachineCategoryList: [
        {
          label: "家用空调",
          value: 101
        },
        {
          label: "电视机",
          value: 102
        },
        {
          label: "热水器",
          value: 103
        },
        {
          label: "电脑",
          value: 104
        },
        {
          label: "冰箱",
          value: 106
        },
        {
          label: "壁挂炉",
          value: 109
        },
        {
          label: "厨大电",
          value: 115
        },
        {
          label: "洗衣机",
          value: 117
        }
      ],
      // 来源系统
      sourceSystemList: [
        {
          label: "4.0",
          value: "4.0"
        },
        {
          label: "3.0",
          value: "3.0"
        }
      ],
      tabActiveName: "补贴待发放"
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  mounted() {},
  watch: {},
  methods: {
    //跳转到详情页
    goDetail(rowData) {
      console.log("看看详情数据", rowData);
      this.$router.push({
        path: "/oldMachineSubsidy/orderDetail",
        query: {
          orderNo: rowData.subsidyNo
        }
      });
    },
    // 发放完成导入
    importSuccessExcel(item) {
      // this.listLoading = true;
      this.upLoadData = item;
      let formData = new FormData();
      formData.append("file", this.upLoadData.file);
      let url = `/autoapp-default-server-recovery/api/oldMachineSubsidy/importSubsidyIssued`;
      this.HttpService.post(url, formData).then(res => {
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data;
            this.$refs.batchReviewImportResultDialogRef.openDialog(
              downloadId,
              1
            );
          } else {
            this.$message.success("发放完成导入成功");
            this.getList();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 发放失败导入
    importFailExcel(item) {
      // this.listLoading = true;
      this.upLoadData = item;
      let formData = new FormData();
      formData.append("file", this.upLoadData.file);
      let url = `/autoapp-default-server-recovery/api/oldMachineSubsidy/importSubsidyIssuedFail`;
      this.HttpService.post(url, formData).then(res => {
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data;
            this.$refs.batchReviewImportResultDialogRef.openDialog(
              downloadId,
              2
            );
          } else {
            this.$message.success("发放失败导入成功");
            this.getList();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 批量开票
    importInvoicingExcel(item) {
      // this.listLoading = true;
      this.upLoadData = item;
      let formData = new FormData();
      formData.append("file", this.upLoadData.file);
      let url = `/autoapp-default-server-recovery/api/oldMachineSubsidy/importSubsidyInvoicing`;
      this.HttpService.post(url, formData).then(res => {
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data;
            this.$refs.BatchInvoiceImportResultDialog.openDialog(
              downloadId,
              3
            );
          } else {
            this.$message.success("批量开票成功");
            this.getList();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取列表数据
    async getList() {
      // if ([1, 2, 3, 4, 5, 6].includes(this.distributionState)) {
      //   this.search.statusList = [this.distributionState];
      // } else {
      //   this.search.statusList = [];
      // }
      this.search.statusList = this.distributionState
        ? [this.distributionState]
        : [3, 4, 5, 6, 7, 8];
      if (this.appraisalTime && this.appraisalTime.length !== 0) {
        this.search.appraisalStartDate = this.appraisalTime[0];
        this.search.appraisalEndDate = this.appraisalTime[1];
      } else {
        this.search.appraisalStartDate = "";
        this.search.appraisalEndDate = "";
      }
      let params = this.search;
      this.list = [];
      // this.listLoading = true;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/oldMachineSubsidy/getOldMachineRepertoryByOutletsNo",
        params
      ).then(res => {
        if (res.statusCode === 200) {
          // 处理旧机品类
          if (res.data && res.data.length !== 0) {
            res.data.forEach(item => {
              if (item.oldMachineType === 101) {
                item.oldMachineTypeName = "家用空调";
              } else if (item.oldMachineType === 102) {
                item.oldMachineTypeName = "电视机";
              } else if (item.oldMachineType === 103) {
                item.oldMachineTypeName = "热水器";
              } else if (item.oldMachineType === 104) {
                item.oldMachineTypeName = "电脑";
              } else if (item.oldMachineType === 106) {
                item.oldMachineTypeName = "冰箱";
              } else if (item.oldMachineType === 109) {
                item.oldMachineTypeName = "壁挂炉";
              } else if (item.oldMachineType === 115) {
                item.oldMachineTypeName = "壁挂炉";
              } else if (item.oldMachineType === 117) {
                item.oldMachineTypeName = "洗衣机";
              }
            });
          }
          this.list = res.data;
          this.total = res.total || 0;
        }
      });
    },
    // 订单发放
    openDistribution(subsidyNo) {
      this.$refs.distributionDialogRef.openDialog(subsidyNo);
    },
    // 发放成功
    distributionFinished() {
      this.getList();
    },
    // 批量发放成功
    batchDistributionFinished() {
      this.getList();
    },
    // 发放完成成功
    distributionFinishedSuccess() {
      this.getList();
    },
    // 发放失败
    distributionFail() {
      this.getList();
    },
    changeDistributionState(val) {
      console.log("改变发放状态", val);
      if (val === 3) {
        this.tabActiveName = "补贴待发放";
      } else if (val === 4) {
        this.tabActiveName = "补贴发放中";
      } else if (val === "") {
        this.tabActiveName = "全部";
      } else {
        this.tabActiveName = "";
      }
    },
    handleSizeChange(val) {
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    resetForm() {
      this.search = this.$options.data().search;
      this.appraisalTime = [];
      this.distributionState = "";
    },
    // 导出
    exportExcel() {
      // if ([1, 2, 3, 4, 5, 6].includes(this.distributionState)) {
      //   this.search.statusList = [this.distributionState];
      // } else {
      //   this.search.statusList = [];
      // }
      this.search.statusList = this.distributionState
        ? [this.distributionState]
        : [3, 4, 5, 6, 7, 8,21];
      if (this.appraisalTime && this.appraisalTime.length !== 0) {
        this.search.appraisalStartDate = this.appraisalTime[0];
        this.search.appraisalEndDate = this.appraisalTime[1];
      } else {
        this.search.appraisalStartDate = "";
        this.search.appraisalEndDate = "";
      }

      console.log("打印", this.search, this.distributionState);
      let params = this.search;
      let url = `/autoapp-default-server-recovery/api/oldMachineSubsidy/exportVerify`
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleClick(tab, event) {
      console.log("点击tab", tab.label);
      if (tab.label === "全部") {
        this.distributionState = "";
      } else if (tab.label === "补贴待发放") {
        this.distributionState = 3;
      } else if (tab.label === "补贴发放中") {
        this.distributionState = 4;
      }
      this.getList();
    },
    // 发放成功模板下载‘
    downloadSuccessTemplate() {
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/oldMachineSubsidy/downloadWdIssuedTemplate`,
          {},
          "发放成功模板"
        )
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    },
    // 发放失败模板下载‘
    downloadFailTemplate() {
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/oldMachineSubsidy/downloadWdIssuedFailTemplate`,
          {},
          "发放失败模板"
        )
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    },
    // 批量开票模板下载‘
    downloadInvoicingTemplate() {
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/oldMachineSubsidy/downloadInvoicingTemplate`,
          {},
          "批量开票模板"
        )
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    },
    // 批量发放
    batchDistribution() {
      this.$refs.batchDistributionDialogRef.openDialog();
    },
    // 发放完成
    openDistributionSuccess(orderId) {
      this.$refs.distributionSuccessDialogRef.openDialog(orderId);
    },
    // 发放失败
    openDistributionFail(orderId) {
      this.$refs.distributionFailDialogRef.openDialog(orderId);
    },
    finishInvoice(orderId) {
      this.$dialog({
        title: "开票完成确认",
        content:
          "确认已完成开票？",
        cancel_buttton: "取消",
        ok_buttton: "确认",
        width: "400px",
        footBtn: "card",
        dialogType: "sighicon",
        onOk: () => {
          this.HttpService.post(
            "/autoapp-default-server-recovery/api/oldMachineSubsidy/invoicingCompleted",
            {subsidyNos:[orderId]}
          ).then(res => {
            if (res.statusCode === 200) {
              this.$message.success('开票成功')
              this.getList();
            }else {
              this.$message.error(res.message)
            }
          });
        },
        onCancel: () => {
          console.log("cancel");
        },
      });
    }
  },
  components: {
    BatchInvoiceImportResultDialog,
    fileUpload,
    distributionDialog,
    batchDistributionDialog,
    distributionSuccessDialog,
    distributionFailDialog,
    distributionImportResultDialog,
    batchReviewImportResultDialog
  }
};
</script>

<style scoped lang="scss">
.row-bg {
  margin-bottom: 15px;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;

  span {
    min-width: 100px;
  }
}
.button-container {
  display: flex;
  margin-bottom: 15px;
  margin-left: 20px;
  .distribution-import-button {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/subsidyDistribution.vue